import React from 'react'
import DefaultLink from '../../components/DefaultLink'
import { useModal } from '../../contexts/ModalContext';

const data = [
  {
    img: "/assets/images/about-goal-1.webp",
    title: "Easy-to-use PDF editing",
    desc: "Create, edit, convert, sign, share PDFs in a simplified interface.",
    slug: "",
    btn: "Explore",
  },
  {
    img: "/assets/images/about-goal-2.webp",
    title: "Secure, compliant eSigning",
    desc: "Deliver seamless eSigning with simple to advanced options to fit your needs.",
    slug: "",
    btn: "Explore",
  },
  {
    img: "/assets/images/about-goal-3.webp",
    title: "Comprehensive insights",
    desc: "Track ROI, sustainability, productivity, adoption for data-driven decisions.",
    slug: "",
    btn: "Explore",
  },
  {
    img: "/assets/images/about-goal-4.webp",
    title: "Secure AI automation",
    desc: "Innovative AI tools to save time, gain insights, simplify daily tasks.",
    slug: "",
    btn: "Explore",
  },
  {
    img: "/assets/images/about-goal-5.webp",
    title: "Digital transformation",
    desc: "Learn how we helps you simplify and support your digital journey.",
    slug: "",
    btn: "Explore",
  },
  {
    img: "/assets/images/about-goal-6.webp",
    title: "Sustainability",
    desc: "See how to increase and measure ROI for your business and the planet.",
    slug: "",
    btn: "Explore",
  },
]

export default function AboutGoals() {
   const { openQueryModal } = useModal();
  return (
    <>
      <section className="about-goals-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="about-goals-head">
                <h3 className="heading center-heading">Achieve Business Efficiency Faster with Dox and Box Solutions</h3>
              </div>
            </div>

            {data?.map((item, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div className="about-goals-box">
                  <img src={item?.img} alt="goal box" />
                  <span>{item?.title}</span>
                  <p>{item?.desc}</p>
                  <DefaultLink to={item?.slug} onClick={openQueryModal} text={item?.btn} />
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>
    </>
  )
}
